import theme from '../../styles/theme';
export const alignments = {
    center: 'center',
    top: 'top',
};
export const variations = {
    alert: 'alert',
    dark: 'dark',
    green: 'green',
    light: 'light',
    overlay: 'overlay',
};
const legacyAccentColor = '#91ac4c';
export const spinnerColors = {
    alert: '#eba9b6',
    dark: theme.colors.gray500,
    green: legacyAccentColor,
    light: theme.colors.gray100,
    overlay: legacyAccentColor,
};
